// extracted by mini-css-extract-plugin
export default {"container":"EmployeesPage_container__1OwtI","noEmployeesContainer":"EmployeesPage_noEmployeesContainer__ApuWw","noEmployeesText":"EmployeesPage_noEmployeesText__-mtq2"};